import type { FC, SVGProps } from 'react';

export const PoshmarkLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
      fill="#751B4B"
    />
    <path
      d="M8 8h8v1.5H8V8zm0 2.5h8V12H8v-1.5zm0 2.5h8V14H8v-1.5zm0 2.5h5V16H8v-1.5z"
      fill="white"
    />
  </svg>
);
